<template>
  <div class="user-profile--programs-list">
    <v-row>
      <v-col cols="12" sm="12" md="12" class="d-flex justify-end">
        <v-btn text :to="{ name: 'user.program-history' }">
          <v-icon class="mr-2"> {{ icons.back }} </v-icon>
          Back to Program History
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <program-history-table
          :programs="completedPrograms"
          :loading="loading"
          @goTo="goTo"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProgramHistoryTable from '../components/ProgramHistoryTable'

import { mdiArrowLeft } from '@mdi/js'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'UserCompletedPrograms',

  components: {
    ProgramHistoryTable,
  },

  data() {
    return {
      loading: false,
      icons: {
        back: mdiArrowLeft,
      },
    }
  },

  created() {
    this.fetchCompletedPrograms()
  },

  destroyed() {
    this.clearCompletedPrograms()
  },

  computed: {
    ...mapState({
      completedPrograms: (state) => state.userProfile.completedPrograms,
    }),
  },

  methods: {
    ...mapActions({ getCompletedPrograms: 'userProfile/getCompletedPrograms' }),
    ...mapMutations({
      clearCompletedPrograms: 'userProfile/clearCompletedPrograms',
    }),

    async fetchCompletedPrograms() {
      this.loading = true

      await this.getCompletedPrograms(this.$route.params.id)

      await this.$sleep()

      this.loading = false
    },

    goTo(programId) {
      this.$router.push({
        name: 'user.program-history.details',
        params: { programId },
      })
    },
  },
}
</script>
